import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

class MailPreview extends Component {

  render() {
    return (
      <div className="mailpreview">
        <div className="meta" style={{borderBottom: '1px solid #ccc', paddingBottom: '15px', marginBottom: '15px'}}>
          <strong>
            <FormattedMessage
              id="Supporter.MailPreview.To"
              defaultMessage="An:"
            />
          </strong> {this.props.to}<br/>
          <strong>
            <FormattedMessage
              id="Supporter.MailPreview.From"
              defaultMessage="Von:"
            />
          </strong> {this.props.from}<br/>
          <strong>
            <FormattedMessage
              id="Supporter.MailPreview.Subject"
              defaultMessage="Betreff:"
            />
          </strong> {this.props.subject}<br/>
        </div>
        <div className="body">
          {this.props.body}
        </div>
      </div>
    )
  }
};

export default MailPreview;


// WEBPACK FOOTER //
// ./src/MailPreview.js